import { Component, HostListener, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-logo-context-menu',
  templateUrl: './logo-context-menu.component.html',
  styleUrls: ['./logo-context-menu.component.scss']
})
export class LogoContextMenuComponent implements AfterViewInit {
  @ViewChild('contextMenu', { read: ElementRef }) contextMenuRef: ElementRef | undefined;
  @ViewChild('trigger', { read: ElementRef }) triggerRef: ElementRef | undefined;

  isOpen = false;
  positionTop = false;
  positionRight = false;
  private closeTimer: ReturnType<typeof window.setTimeout> | null = null;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.logo-context-menu')) {
      this.closeMenu();
    }
  }

  ngAfterViewInit(): void {
    if (this.isOpen) {
      this.calculateMenuPosition();
    }
  }

  toggleMenu(): void {
    this.clearCloseTimer();
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      window.requestAnimationFrame(() => this.calculateMenuPosition());
    }
  }

  // Use this when opening via hover so we measure after the menu becomes visible
  openMenu(): void {
    this.clearCloseTimer();
    this.isOpen = true;
    window.requestAnimationFrame(() => this.calculateMenuPosition());
  }

  scheduleCloseMenu(): void {
    this.clearCloseTimer();
    this.closeTimer = window.setTimeout(() => this.closeMenu(), 180);
  }

  cancelCloseMenu(): void {
    this.clearCloseTimer();
  }

  closeMenu(): void {
    this.clearCloseTimer();
    this.isOpen = false;
  }

  private clearCloseTimer(): void {
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  private calculateMenuPosition(): void {
    if (!this.contextMenuRef || !this.triggerRef) return;

    const menuEl = this.contextMenuRef.nativeElement as HTMLElement;
    const triggerEl = this.triggerRef.nativeElement as HTMLElement;

    const triggerRect = triggerEl.getBoundingClientRect();
    const menuRect = menuEl.getBoundingClientRect();

    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const gap = 12;

    // Check if menu would extend below viewport bottom
    const menuBottomPosition = triggerRect.bottom + gap + menuRect.height;
    this.positionTop = menuBottomPosition > viewportHeight;

    // Check if menu would extend past right viewport edge
    const menuRightPosition = triggerRect.left + menuRect.width;
    this.positionRight = menuRightPosition > viewportWidth;
  }
}